import React from 'react';

import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
  const {
    // @ts-ignore
    custom: {
      palette: { colorSupportSlate },
    },
    palette: {
      common: { white },
    },
    spacing: { unit },
  } = theme;

  return {
    link: {
      color: white,
    },
    root: {
      backgroundColor: colorSupportSlate,
      fontWeight: 600,
      padding: `${unit / 2}px 0px ${unit / 2}px ${unit * 6}px`,
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    text: {
      color: white,
      fontSize: 23,
      textAlign: 'center' as 'center',
    },
  };
};

interface Props extends WithStyles {}

const InternetExplorerAlert: React.FC<Props> = ({ classes }) => (
  // TODO: Use SnackbarContent instead of using custom styles
  <div className={classes.root}>
    <span className={classes.text}>
      This application no longer supports Internet Explorer 11.
      <br /> Please use a supported browser, such as&nbsp;
      <a className={classes.link} href="https://www.google.com/chrome/browser/desktop/index.html">
        Google Chrome
      </a>
      ,&nbsp;
      <a className={classes.link} href="https://www.mozilla.org/firefox/new/">
        Mozilla Firefox
      </a>
      ,&nbsp;
      <a className={classes.link} href="https://www.microsoft.com/en-us/edge">
        Microsoft Edge
      </a>
      &nbsp;or&nbsp;
      <a className={classes.link} href="https://support.apple.com/downloads/safari">
        Safari
      </a>
      .
    </span>
  </div>
);

export default withStyles(styles)(InternetExplorerAlert);
